// The soundtrack and the assisted instrument share one harmonic progression.
export const CHORD_PROGRESSION = [130.81, 103.83, 155.56, 116.54];
const VOICINGS = [1, 1.5, 2, 1.2, 1.5, 2, 1.2, 1.5];

export const getChordRoot = (tick) => CHORD_PROGRESSION[Math.floor(Math.max(0, tick) / 16) % 4];
export const getNoteVoice = (tick, lane) => {
  const root = getChordRoot(tick);
  const index = (Math.floor(tick / 2) + (lane === 'right' ? 3 : 0)) % VOICINGS.length;
  return { frequency: root * 2 * VOICINGS[index], brightness: lane === 'left' ? 1500 : 2300 };
};

export const noteSoundKey = (tick, lane) => `${tick}:${lane}`;
